module.exports = __webpack_public_path__ + "static/media/what-is-a-wireframe-why-is-wireframing-so-important.1e27e30d.svg";